import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { LogLevel } from "./types.js";
const initialState = { level: LogLevel.warn }, LoggerContext = createContext(initialState);
function LoggerContextProvider(props) {
  const { level = initialState.level } = props;
  return /* @__PURE__ */ jsx(LoggerContext.Provider, { value: { level }, children: props.children });
}
export {
  LoggerContext,
  LoggerContextProvider
};
//# sourceMappingURL=LoggerContext.js.map
